import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/userpointslog/list",
      method: "get",
      params: query
    });
  },
  // 详情
  jifenfafanglogdetail(id) {
    return request({
      url: `/jifenfafanglog/detail`,
      method: "post",
      data: { id }  
    });
  },

  // jifenfafangloglist 积分发放日志列表
  jifenfafangloglist(query) {
    return request({
      url: "/jifenfafanglog/list",
      method: "get",
      params: query
    });
  },
  // 新增积分发放日志
  jifenfafanglogcreate(data) {
    return request({
      url: "/jifenfafanglog/create",
      method: "post",
      data: data
    });
  },
  // 编辑积分发放日志
  jifenfafanglogedit(data) {
    return request({
      url: "/jifenfafanglog/edit",
      method: "post",
      data: data
    });
  },
  // 导出积分发放日志
  jifenfafanglogexport(data) {
    return request({
      url: "/jifenfafanglog/export",
      method: "post",
      data: data
    });
  }

};
export default index;
